import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'

const AccordionItem = ({ children }) => {
  return <div>{children}</div>
}

AccordionItem.propTypes = {
  children: PropTypes.node.isRequired
}

const Accordion = ({
  contentComponent: ContentComponent,
  headerComponent: HeaderComponent,
  items,
  headerProps,
  contentProps,
  dataTest,
  initialActive = 0
}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(initialActive)

  function toggleAccordion(index) {
    if (activeItemIndex === index) {
      return setActiveItemIndex(null)
    }
    setActiveItemIndex(index)
  }

  function closeAccordion () {
    setActiveItemIndex(null)
  }

  const accordionItems = useMemo(() => {
    return items.map((item, index) => {
      return (
        <AccordionItem key={item.id || item.key || index}>
          <>
            <div data-test={dataTest}>
              {/* eslint-disable-next-line no-magic-numbers */}
              <HeaderComponent item={item} lastItem={index + 1 === items.length}
                isOpen={activeItemIndex === index} {...headerProps} toggleAccordion={() => {
                  toggleAccordion(index)
                }} closeAccordion={closeAccordion}/>
            </div>
            {activeItemIndex === index && <ContentComponent item={item} toggleAccordion={() => {
              toggleAccordion(index)
            }} {...contentProps} />}
          </>
        </AccordionItem>
      )
    })
  }, [items, activeItemIndex])

  return <div>{accordionItems}</div>
}
Accordion.propTypes = {
  contentComponent: PropTypes.elementType.isRequired,
  headerComponent: PropTypes.elementType.isRequired,
  items: PropTypes.array.isRequired,
  headerProps: PropTypes.object,
  contentProps: PropTypes.object,
  dataTest: PropTypes.string,
  initialActive: PropTypes.number
}

export default Accordion
